import qs from 'qs';
import { AxiosInstance } from 'axios';
import { OffsetPaginationInput } from '@app/data/inputs';
import { CollectionResource } from '@app/data/resources';
import { CreateWorkspaceInput } from './inputs';
import { WorkspaceRef } from './refs';
import { WorkspaceResource } from './resources';

export default class Workspace {
    private basePath = '/api/workspace';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Get paginated workspace list
    get = async (
        pagination: OffsetPaginationInput,
        filter?: {},
    ): Promise<CollectionResource<WorkspaceResource, {}>> => {
        const query = qs.stringify({ ...pagination, ...filter });

        const { data } = await this.http.get(`${this.basePath}/?${query}`);

        return data;
    };

    // Create new workspace
    create = async (input: CreateWorkspaceInput): Promise<WorkspaceRef> => {
        const { data } = await this.http.post(`${this.basePath}/`, input);

        return data;
    };

    // Get workspace
    getById = async (id: ID): Promise<WorkspaceResource> => {
        const { data } = await this.http.get(`${this.basePath}/${id}`);

        return data;
    };
    
    
}
